var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "slider" }, [
    _c("div", { ref: "container", staticClass: "slider__container" }, [
      _c(
        "div",
        { ref: "wrapper", staticClass: "slider__wrapper" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.showPrevArrow
        ? _c(
            "div",
            {
              staticClass: "slider__prev",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.prevSlide.apply(null, arguments)
                },
              },
            },
            [_c("span", { staticClass: "fas fa-angle-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNextArrow
        ? _c(
            "div",
            {
              staticClass: "slider__next",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.nextSlide.apply(null, arguments)
                },
              },
            },
            [_c("span", { staticClass: "fas fa-angle-right" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "mobile", staticClass: "slider__mobile" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }